import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchNewFeatures = () => {
  return {
    types: [
      actionTypes.FETCH_NEW_FEATURES_LOADING,
      actionTypes.FETCH_NEW_FEATURES_SUCCESS,
      actionTypes.FETCH_NEW_FEATURES_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/new-features?include_next_features=include_next_features`,
      }),
  };
};
